export function map(data, options) {
  var callback = options.callback;

  if (callback) {
    data.dataArray = data.dataArray.map(callback);
  }

  return data;
}